import api from './httpClient';

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : '';
};

export const fetchCustomers = async (params) => {
  const res = await api.get(`/api/customers${buildQuery(params)}`);
  return res.data;
};

export const fetchCustomer = async (id) => {
  const res = await api.get(`/api/customers/${id}`);
  return res.data;
};

export const createCustomer = async (payload) => {
  const res = await api.post('/api/customers', payload);
  return res.data;
};

export const updateCustomer = async (id, payload) => {
  const res = await api.put(`/api/customers/${id}`, payload);
  return res.data;
};

export const deleteCustomer = async (id) => {
  const res = await api.delete(`/api/customers/${id}`);
  return res.data;
};

export const fetchCustomerReviews = async (customerId) => {
  const res = await api.get(`/api/customers/${customerId}/reviews`);
  return res.data;
};

export const createCustomerReview = async (customerId, payload) => {
  const res = await api.post(`/api/customers/${customerId}/reviews`, payload);
  return res.data;
};

export const fetchCustomerTickets = async (customerId) => {
  const res = await api.get(`/api/customers/${customerId}/tickets`);
  return res.data;
};

export const createCustomerTicket = async (customerId, payload) => {
  const res = await api.post(`/api/customers/${customerId}/tickets`, payload);
  return res.data;
};
